export type IncludedOrNotIncludedTextType = 'plural' | 'singularShe' | 'singularHe' | 'singularIt';

export const getIncludedOrNotIncludedText =
  (type: IncludedOrNotIncludedTextType) =>
  (included: boolean): string => {
    switch (type) {
      case 'plural':
        return included ? 'Включены' : 'Не включены';
      case 'singularHe':
        return included ? 'Включён' : 'Не включён';
      case 'singularIt':
        return included ? 'Включено' : 'Не включено';
      case 'singularShe':
        return included ? 'Включена' : 'Не включена';
      default:
        return included ? 'Включены' : 'Не включены';
    }
  };
